import React from 'react';
import ImportacionMasivaManager from '../Components/Catalogos/ImportacionMasiva/ImportacionMasivaManager';

/**
 * ImportacionMasivaPage - Página unificada para todas las importaciones masivas.
 */
export default function ImportacionMasivaPage() {
    return (
        <ImportacionMasivaManager />
    );
}
